import React, { useState } from "react";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import { useMountedState } from "components/common";
import { InvoiceConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import useBookingTreeSuggestions from "./bookingTree/useBookingTreeSuggestions";

function useInvoiceCategorySuggestions<T extends SelectionItem | AutocompleteListItem>(
  id: number,
  isAutoInvoice: boolean,
  mapFunction: (bookingTreeItems: WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[], group?: string) => T[]
) {
  const { getBookingTipSuggestions } = useBookingTreeSuggestions();
  const { getMounted } = useMountedState();

  const [defaultAccount, setDefaultAccount] = useState<T>();
  const [suggestions, setSuggestions] = useState<T[]>();

  React.useEffect(() => {
    getBookingTipSuggestions(id).then((items) => {
      if (getMounted()) {
        let preSelected;
        const noClueAccount = items.find((i) => i.account === InvoiceConstants.InvoiceCategoryNoClueAccount);
        if (isAutoInvoice) preSelected = noClueAccount;
        else preSelected = items.find((i) => i.isPreSelectedAccount);

        if (preSelected && preSelected.account) setDefaultAccount(mapFunction([preSelected])[0]);

        setSuggestions(
          mapFunction(
            items,
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions)
          )
        );
      }
    });
  }, [id]);

  return {
    defaultAccount: defaultAccount,
    suggestions: suggestions,
  };
}

export default useInvoiceCategorySuggestions;
